$(document).ready(function() {
  $(".gallery .gallery-item a").each(function(){
    $(this).attr("data-fancybox","gallery");
  });
  $("a img").each(function(){
    var img_src = $(this).attr("src");
    var a_href = $(this).parent().attr("href");
    if(img_src == a_href){
       $(this).parent().attr("data-fancybox","gallery");
    }
  });
  $('[data-fancybox]').fancybox({
    loop: true,
    buttons : [
      'close'
    ],
    image : {
      preload : "auto",
    },
    infobar : false,
    hideScrollbar: false,
    hash : false,
    clickContent: false,
    baseTpl :
      '<div class="fancybox-container" role="dialog" tabindex="-1">' +
        '<div class="fancybox-bg"></div>' +
        '<div class="fancybox-inner">' +
          '<div class="fancybox-toolbar">' +
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="close"><span></span><span></span><span></span><span></span><span></span><span></span></button>' +
          '</div>' +
          '<div class="fancybox-navigation">' +
            '<button data-fancybox-prev title="prev" class="fancybox-button fancybox-button--arrow_left"><img src="/zenonzard/images/cardlist/btn_back.png"></button>' +
            '<button data-fancybox-next title="next" class="fancybox-button fancybox-button--arrow_right"><img src="/zenonzard/images/cardlist/btn_next.png"></button>' +
          '</div>' +
          '<div class="fancybox-stage"></div>' +
        '</div>' +
      '</div>',
  });
});